/* レイアウト用論理棚 */
import React from 'react';

const LayoutDivision: React.FC = ({ children }) => {
  return <div className="layout-division">{children}</div>;
};

export default LayoutDivision;
